export default "__VITE_ASSET__DYOpPnyA__"